import type { CallControllerGetCallByIdApiArg } from '@shared/services/apiService/apiService';

export const CALL_DETAIL_TABS = {
  TRANSCRIPT: 'transcript',
  ANALYSIS: 'analysis',
} as const;

export type CallDetailTab = (typeof CALL_DETAIL_TABS)[keyof typeof CALL_DETAIL_TABS];

type CallDetailRelation = NonNullable<CallControllerGetCallByIdApiArg['relations']>;

const CALL_DETAIL_RELATION_PATHS = [
  'customer',
  'customer.campaign',
  'agent',
  'agent.profile',
  'squad',
  'analysis',
] as const satisfies readonly NonNullable<CallControllerGetCallByIdApiArg['relations']>[];

/**
 * Keep the paths page-owned so callers cannot provide arbitrary ORM relations.
 * The runtime array is serialized by query-string as repeated relations query values.
 */
// The generated OpenAPI type models one relation, while this endpoint accepts repeated values.
// Keep the compatibility assertion at this page-owned boundary instead of spreading casts.
export const CALL_DETAIL_RELATIONS = [
  ...CALL_DETAIL_RELATION_PATHS,
] as unknown as CallDetailRelation;
